import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import RBTooltip from 'react-bootstrap/Tooltip';
import * as styles from './Tooltip.module.scss';

const Tooltip = (props) => {
    const {
        tooltip,
        children,
        placement,
        forButton,
        isDisabled,
        stretched,
        show,
    } = props;

    if (isDisabled) {
        return children;
    }

    const containerStyle = useMemo(() => ({
        display: 'inline-flex',
        width: stretched ? '100%' : 'auto',
    }), [stretched]);

    return (
        <OverlayTrigger
            show={show}
            overlay={(
                <RBTooltip className={styles.labelWithInfoIconTooltipRoot}>
                    <div className={styles.labelWithInfoIconTooltip}>
                        {tooltip}
                    </div>
                </RBTooltip>
            )}
            placement={placement}
        >
            {forButton ? <div style={containerStyle} tabIndex="0">{children}</div> : children}
        </OverlayTrigger>
    );
};

Tooltip.propTypes = {
    style: PropTypes.object,
    stretched: PropTypes.bool,
    tooltip: PropTypes.any,
    children: PropTypes.any,
    forButton: PropTypes.bool,
    isDisabled: PropTypes.bool,
    placement: PropTypes.oneOf([
        'auto-start',
        'auto',
        'auto-end',
        'top-start',
        'top',
        'top-end',
        'right-start',
        'right',
        'right-end',
        'bottom-end',
        'bottom',
        'bottom-start',
        'left-end',
        'left',
        'left-start',
    ]),
};

Tooltip.defaultProps = {
    stretched: false,
    tooltip: '',
    forButton: false,
    isDisabled: false,
    children: null,
    placement: 'top',
};

export default Tooltip;
